/**
 * Created by Ruslan Loboda on 8/7/2017.
 */

import Vue from 'vue'

export default {
	get({}, id) {
		return Vue.api.get('city/' + id)
	}
}



// WEBPACK FOOTER //
// ./src/vuex/services/city/actions.js